<div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="10px" class="frame-details-layout" [formGroup]="orderForm">
	<div fxFlex formArrayName="products">


				<div fxLayout="column" fxLayoutAlign="left" fxLayoutGap="0px" style="width:100%" formGroupName="0">

				    <div fxLayout="row" fxLayoutAlign="start end" fxLayoutGap="10px" class="frame-top-row">
				      <div class="frame-pof-field" fxFlex="0 0 40px" [class.pof-selected]="isPofSelected">
				      	<label class="frame-pof-label">POF</label>
				        <mat-checkbox [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['pof']"></mat-checkbox>
				      </div>
				      <div fxFlex="2 1 0" class="frame-field-stretch frame-manufacturer-field">
							<app-autocomplete-vendors 
						    	placeholder="MANUFACTURER" 
						  		[storeOnly]="true"
					  			[(productForm)]="orderForm.controls.products['controls'][0]['controls']['product']" 
						    	fxFlex="1 1 100%"></app-autocomplete-vendors>
				      </div>
				      <div fxFlex="1 1 0" class="frame-field-stretch">
				      	<app-autocomplete-vendor-products
					  			[(productForm)]="orderForm.controls.products['controls'][0]['controls']['product']" 
					  			[(vendor)]="orderForm.controls.products['controls'][0]['controls']['product']['value']['vendor']" 
					  			placeholder="MODEL"
					  			(selected)="onProductFieldSelected($event)"
					  			displayField="model"
								fxFlex="1 1 100%">
							</app-autocomplete-vendor-products>
				      </div>
				      <div fxFlex="1 1 0" class="frame-field-stretch">
				      	<app-autocomplete-vendor-products
					  			[(productForm)]="orderForm.controls.products['controls'][0]['controls']['product']" 
					  			[(vendor)]="orderForm.controls.products['controls'][0]['controls']['product']['value']['vendor']" 
					  			placeholder="COLOR"
					  			(selected)="onProductFieldSelected($event)"
					  			displayField="color"
								fxFlex="1 1 100%">
							</app-autocomplete-vendor-products>
				      </div>
				      <div fxFlex="0 0 100px" class="frame-field-fixed">
				      	<app-autocomplete-vendor-products
					  			[(productForm)]="orderForm.controls.products['controls'][0]['controls']['product']" 
					  			[(vendor)]="orderForm.controls.products['controls'][0]['controls']['product']['value']['vendor']" 
					  			placeholder="SIZE"
					  			(selected)="onProductFieldSelected($event)"
					  			displayField="size"
								fxFlex="1 1 100%">
							</app-autocomplete-vendor-products>
				      </div>
				      <div fxFlex="0 0 100px" class="frame-field-fixed">
				      	<mat-form-field fxFlex="1 1 100%">
									<mat-select placeholder="TYPE" panelClass="frame-select-panel" [formControl]="orderForm.controls.products['controls'][0]['controls']['product']['controls']['type']">
										<mat-option *ngFor="let typeOption of typeOptions" [value]="typeOption.value">
											{{typeOption.viewValue}}
										</mat-option>
									</mat-select>
				        </mat-form-field>
				      </div>
				      <div fxFlex="0 0 50px">
				        <mat-form-field style="width:100%">
				          <input matInput placeholder="QTY" type="" autocomplete="off" formControlName="quantity">
				        </mat-form-field>
				      </div>
				      <div fxFlex="0 0 75px" class="frame-spc-order">
				      	<label>SPC ORDER</label>
				      	<mat-checkbox aria-label="SPC ORDER" [formControl]="orderForm.controls.specialOrder"></mat-checkbox>
				      </div>
				      <div fxFlex="0 0 80px" class="frame-spc-order" *ngIf="orderForm.get('superbillRequested')">
				      	<label>SUPERBILL</label>
				      	<mat-checkbox aria-label="SUPERBILL" [formControl]="orderForm.get('superbillRequested')"></mat-checkbox>
				      </div>
				    </div>

				    <div *ngIf="exchangeDifferenceNote" class="exchange-credit-note">
				      {{ exchangeDifferenceNote }}
				    </div>
				    <div *ngIf="returnCreditNote" class="exchange-credit-note">
				      {{ returnCreditNote }}
				    </div>
				    <div *ngIf="frameOnlyTaxCreditNote" class="exchange-credit-note">
				      {{ frameOnlyTaxCreditNote }}
				    </div>
				    <div *ngIf="redoPaidNote" class="exchange-credit-note">
				      {{ redoPaidNote }}
				    </div>

				    <div class="frame-status-grid">
				    	<div class="frame-status-grid-row frame-measurements-divider-row">
							<mat-form-field class="frame-material-field" appearance="standard" formGroupName="frame">
							  <mat-label>MATERIAL</mat-label>
							  <mat-select formControlName="material" panelClass="frame-select-panel">
							    <mat-option value="">—</mat-option>
							    <mat-option *ngFor="let option of materialOptions" [value]="option.label">
							      {{ option.label | uppercase }}
							    </mat-option>
							  </mat-select>
							</mat-form-field>
					    	<div class="frame-status-right-col frame-measurements-row">
					      		<div class="frame-measurement-cell">
					      			<div class="frame-measurement-input-line">
					      				<span class="frame-measurement-badge">A</span>
					      				<mat-form-field class="frame-measurement-input" appearance="standard" floatLabel="never">
					          				<input matInput type="text" inputmode="numeric" maxlength="2" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['measurements']['controls']['a']" (input)="onMeasurementInput($event, 'a')">
					        				</mat-form-field>
					      			</div>
					      		</div>
					      		<div class="frame-measurement-cell">
					      			<div class="frame-measurement-input-line">
					      				<span class="frame-measurement-badge">B</span>
					      				<mat-form-field class="frame-measurement-input" appearance="standard" floatLabel="never">
					          				<input matInput type="text" inputmode="numeric" maxlength="2" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['measurements']['controls']['b']" (input)="onMeasurementInput($event, 'b')">
					        				</mat-form-field>
					      			</div>
					      		</div>
					      		<div class="frame-measurement-cell">
					      			<div class="frame-measurement-input-line">
					      				<span class="frame-measurement-badge">ED</span>
					      				<mat-form-field class="frame-measurement-input" appearance="standard" floatLabel="never">
					          				<input matInput type="text" inputmode="numeric" maxlength="2" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['measurements']['controls']['ed']" (input)="onMeasurementInput($event, 'ed')">
					        				</mat-form-field>
					      			</div>
					      		</div>
					      		<div class="frame-measurement-cell">
					      			<div class="frame-measurement-input-line">
					      				<span class="frame-measurement-badge">DBL</span>
					      				<mat-form-field class="frame-measurement-input" appearance="standard" floatLabel="never">
					          				<input matInput type="text" inputmode="numeric" maxlength="2" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['measurements']['controls']['dbl']" (input)="onMeasurementInput($event, 'dbl')">
					        				</mat-form-field>
					      			</div>
					      		</div>
					    	</div>
				    	</div>

				    </div>

					<div class="frame-inner-section">
					  <div class="frame-notes" formGroupName="frame">
					    <label class="frame-notes-label">FRAME NOTES</label>
					    <div class="frame-notes-history" *ngIf="frameNoteEntries.length">
					      <div class="frame-note-entry" *ngFor="let entry of frameNoteEntries">
					        <div class="frame-note-meta" *ngIf="!entry.legacy">
					          {{ entry.timestamp }} &ndash; {{ entry.initials }}
					        </div>
					        <div class="frame-note-meta frame-note-meta-legacy" *ngIf="entry.legacy">
					          Previous notes
					        </div>
					        <div class="frame-note-text">{{ entry.text }}</div>
					      </div>
					    </div>
					    <mat-form-field appearance="fill" class="frame-notes-field">
					      <mat-label>Add note</mat-label>
					      <textarea
					        matInput
					        rows="3"
					        [value]="frameNoteDraft"
					        (input)="frameNoteDraft = $any($event.target).value"
					        (keydown.control.enter)="appendFrameNote()"
					      ></textarea>
					    </mat-form-field>
					    <div class="frame-notes-actions">
					      <button
					        mat-stroked-button
					        type="button"
					        (click)="appendFrameNote()"
					        [disabled]="!canAppendFrameNote"
					      >
					        ADD NOTE
					      </button>
					    </div>
					  </div>
					</div>

					<div class="frame-inner-section">
					  <div class="frame-inner-section-header">ADDITIONS</div>
					  <div class="frame-additions-row" formGroupName="frame">
					    <mat-checkbox class="frame-additions-check" formControlName="nosepadInstall">NOSEPADS INSTALL</mat-checkbox>
					    <mat-checkbox class="frame-additions-check" formControlName="duty">DUTY</mat-checkbox>
					    <mat-checkbox class="frame-additions-check" formControlName="partOther">PART / OTHER</mat-checkbox>
					    <mat-form-field appearance="standard" class="frame-part-other-description">
					      <input matInput type="" autocomplete="off" formControlName="partOtherDescription">
					    </mat-form-field>
					    <mat-form-field appearance="standard" class="frame-part-other-price">
					      <input matInput placeholder="" type="" autocomplete="off" formControlName="partOtherPrice" (input)="updateCustomAmount()" (blur)="formatCurrency($event, orderForm.controls.products['controls'][0]['controls']['frame']['controls']['partOtherPrice']); updateCustomAmount()">
					      <span matPrefix>$&nbsp;</span>
					    </mat-form-field>
					  </div>
					</div>

					<div class="frame-inner-section">
					  <div class="frame-inner-section-header">TASK / ACTIVITY</div>
					  <app-task-activity
					    [orderForm]="orderForm"
					    [patient]="patient"
					    [locked]="isLockedCompleted"
					    (saveOrder)="onTaskWorkflowSave($event.destination)"
					  ></app-task-activity>
					</div>

				</div>

      </div>
      <div fxFlex="0 0 225px" class="frame-details-sidebar">
  			<mat-card class="frame-thumbnail-card">
  				<mat-card-content class="frame-thumbnail-box">
					<app-image
						*ngIf="frameImages?.length; else frameImageUpload"
						[image]="frameImages[0]"
						[tmp]="false"
						type="product"
						[productId]="selectedProductId"
						[edit]="true"
						[delete]="true"
						[active]="true"
						(imageDelete)="onFrameImageDelete($event)"
						(imageReplace)="onFrameImageReplace($event)"
					></app-image>
					<ng-template #frameImageUpload>
						<app-image
							type="product"
							[upload]="true"
							[autoCrop]="true"
							[active]="true"
							[productId]="selectedProductId"
							(imageAdd)="onFrameImageAdd($event)"
						></app-image>
					</ng-template>
  				</mat-card-content>
  			</mat-card>
  			<mat-card class="frame-pricing-box">
  				<mat-card-content>
		  			<mat-form-field style="width:100%">
		          <input matInput placeholder="TAX" type="" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['tax']" (blur)="formatCurrency($event, orderForm.controls.products['controls'][0]['controls']['tax']); updateSubtotal()">
		          <span matPrefix>$&nbsp;</span>
		        </mat-form-field>
		  			<mat-form-field style="width:100%">
		          <input matInput placeholder="FRAME" type="" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['retail']" [readonly]="isPofSelected" (blur)="formatCurrency($event, orderForm.controls.products['controls'][0]['controls']['retail']); updateSubtotal()">
		          <span matPrefix>$&nbsp;</span>
		        </mat-form-field>
		  			<mat-form-field style="width:100%">
		          <input matInput placeholder="CUSTOM" type="" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['custom']" (blur)="formatCurrency($event, orderForm.controls.products['controls'][0]['controls']['custom']); updateSubtotal()">
		          <span matPrefix>$&nbsp;</span>
		        </mat-form-field>
		        <mat-form-field style="width:100%">
		          <input matInput placeholder="SUBTOTAL" type="" autocomplete="off" [formControl]="orderForm.controls.products['controls'][0]['controls']['subtotal']" readonly>
		          <span matPrefix>$&nbsp;</span>
		        </mat-form-field>
		      </mat-card-content>
		    </mat-card>

		    <mat-card class="frame-choice-card">
		      <div class="frame-choice-card-title">FRAME STATUS</div>
		      <mat-radio-group
		        class="frame-choice-radios"
		        [formControl]="orderForm.controls.products['controls'][0]['controls']['frame']['controls']['physicalStatus']"
		        (change)="onPhysicalStatusChange($event.value)"
		      >
		        <mat-radio-button
		          *ngFor="let option of physicalStatusChoices"
		          [value]="option"
		          (click)="onPhysicalStatusClick(option, $event)"
		        >
		          {{ option }}
		        </mat-radio-button>
		      </mat-radio-group>
		    </mat-card>

		    <mat-card class="frame-choice-card">
		      <div class="frame-choice-card-title">JOB ACTIONS</div>
		      <div class="frame-choice-radios">
		        <mat-checkbox
		          *ngFor="let option of jobActionOptions"
		          [checked]="isJobActionChecked(option)"
		          [disabled]="isLockedCompleted"
		          (change)="onJobActionCheck(option, $event.checked)"
		        >
		          {{ option }}
		        </mat-checkbox>
		      </div>
		      <mat-checkbox
		        class="frame-only-checkbox"
		        [formControl]="orderForm.controls.frameOnly"
		        (change)="onFrameOnlyChange($event.checked)"
		      >
		        FRAME ONLY
		      </mat-checkbox>
		    </mat-card>

				<mat-card style="margin-top:10px;" class="order-commit-card">
				<mat-card-content class="order-commit-card-content">

					<button
						mat-stroked-button
						type="button"
						class="ack-commit-button"
						(click)="onSave('CUSTOMER ACKNOWLEDGEMENT')"
					>
						CUSTOMER ACKNOWLEDGEMENT
					</button>

					<app-last-editor-field [orderForm]="orderForm"></app-last-editor-field>

	  			<mat-form-field class="order-initials-field" floatLabel="never">
			      <input matInput required placeholder="" type="text" formControlName="initials">
			      <mat-label><mat-icon>gesture</mat-icon></mat-label>
			    </mat-form-field>

			    <app-order-save-menu [orderForm]="orderForm" [splitSave]="true" (saveOrder)="onSave($event.destination)"></app-order-save-menu>

	      </mat-card-content>
	    </mat-card>
   		</div>
    </div>